import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { EmptyListIllustration, InfoCircleIcon } from '../Icons';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import { useParams } from 'react-router-dom';
import CustomTooltip from '../CustomTootip/CustomTooltip';

interface EmptyStateProps {
	showProductCatalog: (value: boolean) => void;
	isSupplierCatalog: boolean;
	draft: any;
}

const EmptyStateComponent: FC<EmptyStateProps> = ({
	showProductCatalog,
	isSupplierCatalog,
	draft,
}) => {
	const { waId } = useParams();
	const checkPermission = usePermission();
	const canCreateOrderbook = checkPermission(
		ALL_PERMISSION_MAP?.RESTAURANT?.ORDER_BOOK?.CREATE,
		waId
	);
	return (
		<Box
			sx={{
				height: '72vh',
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
				'@media (max-width: 820px)': {
					height: 'calc(100vh - 285px)',
				},
			}}
		>
			<div
				style={{
					height: '80%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<EmptyListIllustration />

				<Typography
					variant="body1"
					sx={{
						width: '257px',
						mt: '-20px',
						color: '#7D7D7D',
						textAlign: 'center',
						'@media (max-width: 820px)': {
							fontSize: '14px',
							lineHeight: '19px',
						},
					}}
				>
					{isSupplierCatalog ? (
						'No products found for this supplier'
					) : (
						<>
							You haven't created an Order Book for this supplier.{' '}
							{canCreateOrderbook ? (
								<span
									style={{ color: '#1A1D1F', fontWeight: '700', cursor: 'pointer' }}
									onClick={() => showProductCatalog(true)}
								>
									Create One now
								</span>
							) : (
								<CustomTooltip
									placement="top"
									title="You do not have permission to create orderbook. Contact 
			an administrator to get permission."
								>
									<span
										style={{ color: '#1A1D1F', fontWeight: '700', cursor: 'pointer' }}
										onClick={() => {}}
									>
										Create One now
									</span>
								</CustomTooltip>
							)}
						</>
					)}
				</Typography>
			</div>
			{isSupplierCatalog ? null : (
				<div style={{ height: 'auto', marginLeft: '8px', color: '#5C5C5C' }}>
					<div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
						<InfoCircleIcon />
						<Typography
							variant="body2"
							sx={{
								ml: '10px',
								'@media (max-width: 820px)': {
									fontSize: '12px',
									lineHeight: '16px',
								},
							}}
						>
							WHAT IS AN ORDER BOOK?
						</Typography>
					</div>
					<Typography
						variant="body2"
						sx={{
							width: '765px',
							'@media (max-width: 820px)': {
								width: '100%',
								fontSize: '12px',
								lineHeight: '16px',
							},
						}}
					>
						Order book is like a shopping list. It is a list of items you typically order from this
						supplier. We use this to automatically fill your shopping cart and you simply have to
						adjust quantities. This makes ordering super easy and fast.
					</Typography>
				</div>
			)}
		</Box>
	);
};

export default EmptyStateComponent;
